(function () {
    'use strict';

    angular.module('core.config', ['core.constant', 'environment', 'tandibar/ng-rollbar']);
})();
